<template>
	<div class="home">
			<section
			id="welcome"
			class="hide-overflow"
		>
			<v-layout>
				<v-flex
					hidden-sm-and-down
					md6
				>
					<v-img
						:src="require('@/assets/bed.jpg')"
						height="100vh"
					/>
				</v-flex>
	
				<v-flex
					xs12
					md6
					align-content-space-between
					layout
					:pa-5="$vuetify.breakpoint.smAndDown"
					wrap
				>
									<v-layout
						align-center
						justify-center
					>
						<v-flex
							xs10
							md6
						>
						<h1
						class="display-3 v-heading mb-3 font-weight-light"
					>
					Welcome!
			</h1>
							<p
							class="subheading  font-weight-light"
							style="line-height: 1.7 !important;"
						>
								This app is designed to assist people in having an open discussion about <strong>Sexy</strong> things they want to do, will try, or have no interest in doing. Once complete, users will have a full, informed, consent-based <strong>Todo</strong> list that will be fun to check off and guarenteed to spice things up.
			</p>
			<!-- <p
			class="subheading font-weight-light"
			style="line-height: 1.7 !important;">
				To find out more about the platform and answers to common questions, click <router-link to="faq" tag="span">Learn More</router-link> button below, otherwise, <router-link to="start" tag="span">Let's Begin</router-link>
			</p> -->
			<p
			class="subheading font-weight-light"
			style="line-height: 1.7 !important;">Coming Soon...</p>
			<!-- <v-btn
			flat
			color="orange"
			class="mt-4"
			to="/faq"
		>
			Learn More
		</v-btn>
		<v-btn
		to="/Start"
		color="primary"
		rounded
		class="mt-4"
	>
		Let's Begin!
	</v-btn> -->
						</v-flex>
					</v-layout>

				</v-flex>
			</v-layout>
		</section>
		<!-- <v-btn to="/start" color="primary" class="ma-2 flex grow"
			>Let's Begin</v-btn
		>
		<v-btn to="/faq" color="secondary" class="ma-2">What is this?</v-btn>

		<v-card class="ma-1 elevation-1">
			<v-card-title class="pa-2"><span>Let's Begin</span> </v-card-title>
		</v-card>

		<v-card class="ma-1 elevation-1">
			<v-card-title class="pa-2"><span>What is this?</span> </v-card-title>
		</v-card>

		<v-card class="ma-1 elevation-1">
			<v-card-title class="pa-2"
				><span> What would you like to do?</span>
			</v-card-title>
			<v-card-text class="pt-0">
				<v-list dense>
					<Join></Join>
					<router-link tag="v-list-tile" to="/joinSession" @click="">
						<v-list-tile-avatar>
							<v-icon class="">link</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							My partner sent me a code
						</v-list-tile-content>
					</router-link>
					<router-link tag="v-list-tile" to="/session/new" @click="">
						<v-list-tile-avatar>
							<v-icon class="">list_alt</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>Start a new ToDo</v-list-tile-content>
					</router-link>

					<router-link tag="v-list-tile" to="/profile" @click="">
						<v-list-tile-avatar>
							<v-icon class="">person</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>I want to login</v-list-tile-content>
					</router-link>
					<router-link tag="v-list-tile" to="/profile" @click="">
						<v-list-tile-avatar>
							<v-icon class="">edit</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content
							>I want to create an account</v-list-tile-content
						>
					</router-link>
					<router-link tag="v-list-tile" to="/faq" @click="">
						<v-list-tile-avatar>
							<v-icon class="">help</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content
							>Frequently Asked Questions</v-list-tile-content
						>
					</router-link>
				</v-list>
			</v-card-text>
		</v-card>
		<Question></Question>
		<Results></Results> -->
	</div>
</template>

<script>
	// @ is an alias to /src
	import Question from '@/components/Question'
	import Results from '@/components/Results'
	import Join from '@/components/Join'

	export default {
		name: 'home',
		components: {
			Question,
			Results,
			Join,
		},
	}
</script>
<style>
	.home {
		height: 100%;
		background: #FFF;
	}
</style>
